import React, { ReactElement, useEffect } from 'react'
import styled from 'styled-components'

import Button from '../../../../../../../../../1stlog-ui/src/components/Button'
import {
  FieldPrefix,
  useField,
} from '../../../../../../../../../1stlog-ui/src/components/Field'
import { useFieldArray } from '../../../../../../../../../1stlog-ui/src/components/FieldArray'
import ListGroup from '../../../../../../../../../1stlog-ui/src/components/ListGroup'
import { usePrevious } from '../../../../../../../../../1stlog-ui/src/hooks'
import HazmatTable from '../../../../../../../../components/Hazmat'
import getDefaultHazmat from '../../../../../Hazmats/getDefaultHazmat'
import Hazmat from '../../../../../Hazmats/Hazmat'
import HazmatColiValidation from '../../../../../Hazmats/HazmatColiValidation'

const Wrapper = styled.div`
  flex: 1 1 auto;
  // margin-right: -1rem;
  margin-left: -2rem;
`

type THazmatOptionProps = {
  disableService: () => void
  coliFieldName: string
  readonly: boolean
}

const HazmatOption = (props: THazmatOptionProps): ReactElement => {
  const { disableService, coliFieldName, readonly } = props

  const { fields } = useFieldArray('value')
  const hazmats = useField('value')

  const { push, remove } = fields

  useEffect(() => {
    if (fields.length < 1) {
      setTimeout(() => push(getDefaultHazmat()), 0)
    }
  }, [])

  const add = (): void => push(getDefaultHazmat())

  const previousLength = usePrevious(fields.length)
  useEffect(() => {
    if (fields.length < 1 && previousLength > fields.length) {
      setTimeout(() => disableService(), 0)
    }
  }, [fields.length])

  return (
    <Wrapper>
      <FieldPrefix prefix={coliFieldName} overwritePrefix>
        <HazmatColiValidation hazmats={hazmats} />
      </FieldPrefix>
      {readonly && <HazmatTable items={hazmats} />}
      <div hidden={readonly}>
        <ListGroup variant="flush">
          {fields.map((name: string, index: number) => (
            <FieldPrefix prefix={name} key={name} overwritePrefix>
              <Hazmat name={name} onRemove={remove} index={index} />
            </FieldPrefix>
          ))}
        </ListGroup>
        <Button onClick={add} xs icon="fas fa-plus" className="mt-1">
          {i18n.t('add_hazmat_item', 'Weiteres Gefahrgut hinzufügen')}
        </Button>
      </div>
    </Wrapper>
  )
}

export default HazmatOption
